<app-loading *ngIf="contentReady"></app-loading>
<div class="addresses-container bg-light">
    <div class="row d-flex justify-content-center align-items-center" style="margin-bottom: 70px;">

        <div>
            <div class="col-12">
                <img style="width: 200px;margin: 0 auto;" src="/assets/e-commerce/icons/62.webp" alt="" />
                <h2>{{'1' | transloco}}</h2>

                <p>{{'2' | transloco}}</p>

                <h3>{{'3' | transloco}}</h3>

                <p>{{'4' | transloco}}</p>

                <p>{{'5' | transloco}}</p>

                <p>{{'6' | transloco}}</p>

                <h3>{{'7' | transloco}}</h3>

                <p>{{'8' | transloco}}</p>

                <p>{{'9' | transloco}}</p>
                <h3>{{'10' | transloco}}</h3>

                <p>{{'11' | transloco}}</p>

                <h3>{{'12' | transloco}}</h3>

                <p>{{'13' | transloco}}</p>

                <p>{{'14' | transloco}}</p>
                <p>{{'15' | transloco}}</p>
                <p>{{'16' | transloco}}</p>
            </div>



        </div>
    </div>